import React from "react";
import devices from "../../assets/image/stella/dispositivos.png";
import {HashLink} from "react-router-hash-link";

function Section2() {
    return (
        <>
            <section className="pt-[100px] max-md:px-5 bg-[#0C0A16]">
                <div className="container text-center max-w-4xl mx-auto"><h2
                    className="text-2xl md:text-[32px] leading-[1.1em] uppercase font-bold mb-6">Renovar cuenta Stella
                    TV: Renovación de usuario online</h2>
                    <div className="leading-[1.5em] max-w-[867px] text-white">Puede
                        <span className="underline"><strong>renovar su misma cuenta</strong></span> siempre
                        y cuando se haya comprado en este sitio web, de no ser así se le <span
                            className="underline"><strong>entrega un usuarios u contraseña nuevo</strong></span>, el
                        cual podrá renovarlo siempre con nosotros. Disfrute del mejor contenido de stellatv.
                    </div>
                </div>
            </section>
            <section className="pt-10 max-md:px-5 bg-[#0C0A16]">
                <div className="container md:max-w-[406px]">
                    <div className="flex gap-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"
                             fill="currentColor" className="w-[50px] h-[50px] text-white">
                            <path
                                d="M435.922 74.352C387.824 26.434 323.84.027 255.742 0 187.797 0 123.711 26.383 75.297 74.29 26.797 122.276.063 186.05 0 253.628v.125c.008 40.902 10.754 82.164 31.152 119.828L.7 512l140.012-31.848c35.46 17.871 75.027 27.293 114.934 27.309h.101c67.934 0 132.02-26.387 180.442-74.297 48.542-48.027 75.289-111.719 75.32-179.34.02-67.144-26.82-130.883-75.586-179.472M255.742 467.5h-.09c-35.832-.016-71.336-9.012-102.668-26.023l-6.62-3.594-93.102 21.176 20.222-91.907-3.898-6.722C50.203 327.004 39.96 290.105 39.96 253.71c.074-117.8 96.863-213.75 215.773-213.75 57.446.024 111.422 22.294 151.985 62.7 41.176 41.031 63.844 94.711 63.824 151.153-.047 117.828-96.856 213.687-215.8 213.687m0 0"></path>
                            <path
                                d="M186.152 141.863h-11.21c-3.903 0-10.239 1.461-15.598 7.293-5.364 5.836-20.477 19.942-20.477 48.63s20.965 56.405 23.887 60.3c2.926 3.89 40.469 64.64 99.93 88.012 49.418 19.422 59.476 15.558 70.199 14.586 10.726-.97 34.613-14.102 39.488-27.715s4.875-25.285 3.414-27.723c-1.465-2.43-5.367-3.887-11.215-6.8-5.851-2.919-34.523-17.262-39.886-19.212-5.364-1.941-9.262-2.914-13.164 2.926-3.903 5.828-15.391 19.313-18.805 23.203-3.41 3.895-6.824 4.383-12.676 1.465-5.852-2.926-24.5-9.191-46.848-29.05-17.394-15.458-29.464-35.169-32.879-41.005-3.41-5.832-.363-8.988 2.57-11.898 2.63-2.61 6.18-6.18 9.106-9.582 2.922-3.406 3.754-5.836 5.707-9.727 1.95-3.89.973-7.296-.488-10.21-1.465-2.919-12.691-31.75-17.895-43.282h.004c-4.382-9.71-8.996-10.039-13.164-10.21m0 0"></path>
                        </svg>
                        <div className="text-left">
                            <HashLink to="to='/#planes'" className="text-lg font-medium text-active underline">Whatsapp</HashLink>
                            <p className="mt-4 text-sm leading-[1.5em] text-white">Soporte online de Lunes a Domingo:
                                7:00AM - 11:00PM
                                (hora Ecuador)</p></div>

                    </div>
                </div>
            </section>

            <section className="pt-16 pb-8 max-md:px-5 bg-gradient-to-b from-[#0c0a16_59%] to-[#dc4600]">
                <div className="section-container text-center">
                    <img alt="como renovar magis tv cuenta" loading="lazy"
                         width="600" height="450" decoding="async"
                         data-nimg="1"
                         className="max-w-full md:max-w-2xl mx-auto"
                         src={devices}
                    /></div>
            </section>

        </>
    );
}

export default Section2;
